var path = 'public/app/plugins/datasource/logging/partials/config.html';
var html = "<datasource-http-settings current=ctrl.current no-direct-access=true>\n</datasource-http-settings>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;